<template>
  <div class="error_indexbox">
    <div class="get_back">
      <a href="javascript:history.go(-1)" class="backward">
        <van-icon
          class="getback_icon"
          name="arrow-left"
          style="font-size:0.2rem;"
        />
        <i class="return">返回</i>
      </a>
    </div>
    <div class="error_content">
      <div slot="error_img" class="tc">
        <img
          src="../../assets/error/app_error.png"
          alt=""
          style="width: 2.0rem;text-align: center;"
        />
      </div>
      <div class="error__line ell">
        <span
          style="
            font-size: 0.18rem;
            color: rgb(51, 51, 51);
            font-weight: bold;
            margin-top: 0.15rem;"
          >糟糕，页面好像出错了</span
        >
      </div>
      <div class="errortext__line ell">
        {{ $route.query.error_msg }}
      </div>
      <div class="flex-1">
        <van-button
          type="primary"
          class="error_btn error_btn_red"
          @click="returnhom"
          >
           <span v-if="isPreOrder">返回预售订单</span>
           <span v-else>返回首页</span>
          </van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Icon } from 'vant'
Vue.use(Button).use(Icon)
export default {
  name: 'error_indexbox',
  data () {
    return {
      // 预售订单
      isPreOrder: ''
    }
  },
  created () {
    if (this.$route.query.type) {
      this.isPreOrder = this.$route.query.type
    }
  },
  methods: {
    returnhom: function () {
      if (this.isPreOrder === '1') {
        this.$router.push({ path: '/presell/order' })
      } else {
        var geturl = this.$route.query.url
        var SkipUrl = geturl.substr(0, 1)
        if (!geturl) {
          geturl = '/home/index'
        } else if (SkipUrl !== '/') {
          geturl = SkipUrl === '\\' ? ('/' + geturl.slice(1)) : ('/' + geturl)
        }
        // this.$router.push(geturl)
        location.href = geturl
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/var.scss";
.error_indexbox{
  background: #ffffff;
  }
.get_back {
  margin-top: 0.1rem;
  margin-left: 0.05rem;
}
.getback_icon i {
  color: #4b4b4b;
  font-size: 0.13rem;
}
.error_content {
  text-align: center;
  margin-top: 1.2rem;
}
.errortext__line {
  font-size: 0.14rem;
  color: #555555;
  margin-top: 0.13rem;
}
.error_btn {
  height: 0.35rem;
  line-height: 0.35rem;
  font-size: 0.14rem;
  width: 1.2rem;
  background: #e1eeff;
  color: #777777;
  border: 1px solid #e1eeff;
  margin-top: 0.12rem;
  border-radius: 0.05rem;
}
.get_back {
  position: relative;
}
.return {
  font-size: 0.17rem;
  position: absolute;
}
</style>
